import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
 
const CustomInput = ({
   label,
   id,
   inputType,
   placeholder,
   onChange,
   errors,
   message,
   name,
   value,
   disabled,
   require,
   containerStyle,
   maxLength,
   ...rest
}) => {
   const [showPassword, setShowPassword] = useState(false);
   const isPassword = inputType === "password";
   const currentType = isPassword ? (showPassword ? "text" : "password") : (inputType ? inputType : "text");

   return (
      <div className="form-group" style={containerStyle}>
         {label && (
            <label className="text-capitalize" htmlFor={id}>
               {label}
               {require && <span className="text-danger">*</span>}
            </label>
         )}
         {isPassword ? (
            <div className="input-group">
               <input
                  type={currentType}
                  className="form-control"
                  id={id}
                  placeholder={placeholder}
                  onChange={onChange}
                  value={value}
                  name={name}
                  maxLength={maxLength}
                  disabled={disabled}
                  {...rest}
               />
               <div 
                  className="input-group-append" 
                  style={{ cursor: "pointer" }} 
                  onClick={() => setShowPassword(!showPassword)}
               >
                  <span className="input-group-text">
                     {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </span>
               </div>
            </div>
         ) : (
            <input
               type={currentType}
               className="form-control "
               id={id}
               placeholder={placeholder}
               onChange={onChange}
               value={value}
               name={name}
               maxLength={maxLength}
               disabled={disabled}
               {...rest}
            />
         )}
         {errors && (
            <div className="text-danger" style={{ fontSize: ".8rem" }}>
               {message}
            </div>
         )}
      </div>
   );
};

export default CustomInput;
